const state = () => ({
    token: false,
    phone: false,
    order: false,
    code_timestamp: 0,
    is_created_order: false
})

const mutations = {
    
    setPhone(state, { phone }) {
        state.phone = phone
    },
    setToken(state, { token }) {
        state.token = token
    },
    setOrder(state, { order }) {
        state.order = order
    },
    setCodeTimestamp(state, { time }) {
        state.code_timestamp = time
    },
    setIsCreatedOrder(state, { status }) {
        state.is_created_order = status
    }
}

const actions = {
    async setPhone({ commit }, { phone }) {
        commit('setPhone', { phone })
    },
    async setToken({ commit }, { token }) {
        commit('setToken', { token })
    },
    async setOrder({ commit }, { order }) {
        commit('setOrder', { order })
    },
    async setCodeTimestamp({ commit }, { time }) {
        commit('setCodeTimestamp', { time })
    },
    async setIsCreatedOrder({ commit }, { status }) {
        commit('setIsCreatedOrder', { status })
    }
}


const getters = {
    token: state => state.token,
    phone: state => state.phone,
    order: state => state.order,
    code_timestamp: state => state.code_timestamp,
    is_created_order: state => state.is_created_order
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};